//API'nin ana adresidir.sunucu adresi değişirse sadece buradan değiştir
export const API_ORIGIN = process.env.REACT_APP_ORIGIN_URL;

if (!API_ORIGIN) {
  throw new Error("REACT_APP_ORIGIN_URL is not defined in .env");
}

export const API_BASE_URL = `${API_ORIGIN}/api/v1`;

// Token helper - localStorage ve sessionStorage'dan token alır
const getToken = () => {
  const persistentToken = localStorage.getItem('accessToken');
  if (persistentToken) return persistentToken;
  return sessionStorage.getItem('accessToken');
};

const removeToken = () => {
  localStorage.removeItem('accessToken');
  sessionStorage.removeItem('accessToken');
};

const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const token = getToken();

  const isFormData = options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, {
      ...options,
      headers,
      credentials: 'include'
    });

    // GÜVENLİK: Eğer sunucu 401 (Unauthorized) dönerse, token artık geçersizdir.
    if (response.status === 401) {
      removeToken();
      // Özel bir hata fırlat - üst katmanda (AuthContext) handle edilecek
      const error = new Error('UNAUTHORIZED');
      error.status = 401;
      throw error;
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error(errorData.message || 'API Hatası');
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    }
    return {};
  } catch (error) {
    throw error;
  }
};

export const authAPI = {
  login: (email, password) => apiCall('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  }),
  me: () => apiCall('/auth/user/me'),
  updateMe: (data) => apiCall('/users/me', {
    method: 'PUT',
    body: JSON.stringify(data),
  }),
  updatePassword: (data) => apiCall('/auth/user/updatePassword', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  activatePendingAccount: (data) => apiCall('/auth/activate_pending_account', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  forgotPassword: (email) => apiCall('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  }),
  resetPassword: (token, newPassword) => apiCall('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, newPassword }),
  }),
  logout: async () => {
    await apiCall('/auth/logout', { method: 'POST' });

    // Clear cookies after logout
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
  },
};


export const categoryAPI = {
  getAll: () => apiCall('/products/categories'),

  add: (data) => apiCall('/products/categories', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  update: (id, data) => apiCall(`/products/categories/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),

  delete: (id) => apiCall(`/products/categories/${id}`, {
    method: 'DELETE'
  })
};




export const purchaseRequestAPI = {
  getAll: () => apiCall('/purchase-requests'),

  getById: (id) => apiCall(`/purchase-requests/${id}`),

  create: (data) => apiCall('/purchase-requests', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // EKSİK OLAN UPDATE METODU (Kaydetme sorununun ana sebebi)
  update: (id, data) => apiCall(`/purchase-requests/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),

  updateStatus: (id, status) => apiCall(`/purchase-requests/${id}/status`, {
    method: 'PUT',
    body: JSON.stringify({ status }),
  }),

  delete: (id) => apiCall(`/purchase-requests/${id}`, {
    method: 'DELETE',
  }),

  // YENİ EKLEDİĞİMİZ FOTOĞRAF SİLME METODU
  deletePhoto: (photoId) => apiCall(`/purchase-request-photos/${photoId}`, {
    method: 'DELETE'
  }),

  uploadPhoto: (id, file, isPrimary = false, sortOrder = 0) => {
    const formData = new FormData();
    // DİKKAT: Backend "file" ismini bekliyor, "photo" değil.
    formData.append('file', file);
    formData.append('isPrimary', isPrimary);
    formData.append('sortOrder', sortOrder);

    return apiCall(`/purchase-requests/${id}/upload-photo`, {
      method: 'POST',
      body: formData,
    });
  }
};






export const productAPI = {
  getAll: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return apiCall(`/products${queryString ? `?${queryString}` : ''}`);
  },

  getById: (id) => apiCall(`/products/${id}`),

  create: (data) => apiCall('/products', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  update: (id, data) => apiCall(`/products/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),

  delete: (id) => apiCall(`/products/${id}`, {
    method: 'DELETE',
  }),

  // Bazı sistemlerde fotoğraf silme ürün güncelleme ile yapılır (pek ihtimal vermiyorum)
  deletePhoto: (photoId) => apiCall(`/product-photos/${photoId}`, {
    method: 'DELETE'
  }),

  uploadPhoto: (id, file, isPrimary = false, sortOrder = 0) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('isPrimary', isPrimary);
    formData.append('sortOrder', sortOrder);

    return apiCall(`/products/${id}/upload-photo`, {
      method: 'POST',
      body: formData,
    });
  }
};




export const announcementsAPI = {
  // Tüm duyuruları listeler (GET /api/v1/announcements)
  getAll: () => apiCall('/announcements'),

  // Yeni duyuru oluşturur (POST /api/v1/announcements)
  // data: { title, shortDescription, fullDescription, visible }
  create: (data) => apiCall('/announcements', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // Mevcut duyuruyu günceller (PUT /api/v1/announcements/:id)
  update: (id, data) => apiCall(`/announcements/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),

  // Duyuruyu siler (DELETE /api/v1/announcements/:id)
  delete: (id) => apiCall(`/announcements/${id}`, {
    method: 'DELETE',
  }),
};



/** Master: sadece kendi şirketinin kullanıcılarını listeler. */
export const masterAPI = {
  getUsers: () => apiCall('/master/getUsers'),
  updateUser: (id, data) => apiCall(`/master/updateUser/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),
  deleteUser: (id) => apiCall(`/master/deleteUser/${id}`, {
    method: 'DELETE',
  }),
};

export const adminAPI = {
  getUsers: () => apiCall('/admin/getUsers'),
  createUser: (userData) => apiCall('/admin/createUser', {
    method: 'POST',
    body: JSON.stringify(userData),
  }),
  updateUser: (id, userData) => apiCall(`/admin/updateUser/${id}`, {
    method: 'PUT',
    body: JSON.stringify(userData),
  }),
  deleteUser: (id) => apiCall(`/admin/deleteUser/${id}`, {
    method: 'DELETE',
  }),
  createPendingAccount: (data) => apiCall('/admin/createPendingAccount', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  getPendingAccounts: () => apiCall('/admin/getPendingAccounts'),
  deletePendingAccount: (id) => apiCall(`/admin/deletePendingAccount/${id}`, {
    method: 'DELETE',
  }),
};

export const companyAPI = {
  // Tüm şirketleri getirir (Admin için)
  getAll: () => apiCall('/companies'),

  // Sadece referans olabilecek şirketleri getirir
  getReferences: () => apiCall('/companies/references'),

  add: (companyData) => apiCall('/companies/add', {
    method: 'POST',
    body: JSON.stringify(companyData),
  }),

  // MASTER ve ADMIN için Şirket Detaylarını Güncelleme [PUT]
  // Gönderilecek data: { name, email, description, shortDescription, address, phoneNumber }
  update: (id, companyData) => apiCall(`/companies/${id}`, {
    method: 'PUT',
    body: JSON.stringify(companyData),
  }),

  delete: (id) => apiCall(`/companies/${id}`, {
    method: 'DELETE',
  }),

  // MASTER ve ADMIN için Şirket Logosu Yükleme [POST]
  // Backend notu: multipart/form-data bekliyor, dosya anahtarı "file" olmalı.
  uploadLogo: (id, file) => {
    const formData = new FormData();
    // Backend "file" anahtarını beklediği için bu şekilde ekliyoruz
    formData.append('file', file);

    return apiCall(`/companies/${id}/upload-logo`, {
      method: 'POST',
      body: formData,
    });
  }
};